import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { TabView, TabPanel } from "primereact/tabview";
import { Button } from "primereact/button";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { SplitButton } from "primereact/splitbutton";

// ------------------ COMPONENTES DE BASE--------------------------
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import { getLabel } from "../../../Base/Services/Language/LanguageService";
import Card from "../../../Base/Components/Card/Card";
import { ConfigContext } from "../../../Base/Context/ConfigContext/ConfigContext";
import { baseLang } from "../../../Base/Lang/BaseLang";
import { setTitlePage } from "../../../Base/Services/Config/ConfigService";
import Loader from "../../../Base/Components/Loader/Loader";
import AgGrid from "../../../Base/Components/Tables/AgGrid/AgGrid";
import { toastShow } from "../../../Base/Services/ToastService";
import { getDatesProduccion } from "../../../Base/Services/Moment/Luxon";
import CalendarWeek from "../../../Base/Components/Form/CalendarWeek";

// ------------------- CONSULTAS A LA API---------------------------
import { EliminarCotizacion, EliminarDetalles, getCotizacionesDet, getCotizacionesEnc } from "../../../API/Ventas/Cotizaciones/CotizacionesRequest";


import CotizacionesCRUD1 from './CRUD/CotizacionesCRUD1'
import ReporteCotizacion from './ReporteCotizacion'


const CotizacionesListScreen = () => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const [activeIndex, setActiveIndex] = useState(0);
  const [dates, setDates] = useState([new Date(), new Date()]);
  const [loading, setLoading] = useState(false);
  const [encabezado, setEncabezado] = useState([]);
  const [detalles, setDetalles] = useState([]);
  const [showDialog, setShowDialog] = useState(false);


  const [selectedEnc, setSelectedEnc] = useState([])
  const [selectedDet, setSelectedDet] = useState([])
  const [selectedR, setSelectedR] = useState([])
  const [habilitar, setHabilitar] = useState(true);
  const [showReporte, setShowReporte]= useState(false);
  const [lenguaje, setLenguaje]= useState('es');


  
  const getInfo = async () => {
    setSelectedR([])
    if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Por favor, seleccione un rango de fechas válido."
      );
      return;
    }

    setLoading(true);
    const fechas = getDatesProduccion(dates);

    const encabezadoTempo = await getCotizacionesEnc(fechas)
    setEncabezado(encabezadoTempo)

    const detallesTempo = await getCotizacionesDet(fechas)
    setDetalles(detallesTempo)

    setLoading(false);
  };

  const AbrirDialog = (data) => {
    setSelectedEnc(data);
    setShowDialog(true);
  };

  const ejecutarEliminar = () => {

    if(activeIndex === 0){
      const mensaje = selectedDet.length > 1 
        ? `¿Está seguro de eliminar los detalles?`
        : `¿Está seguro de eliminar el detalle?`;
    
      if (selectedDet.length <= 0) {
        toastShow(
          toast,
          "warn",
          "Advertencia",
          `Seleccione al menos un detalle.`
        );
      } else {
        confirmDialog({
          message: mensaje,
          header: "Eliminar Detalle",
          icon: "pi pi-exclamation-triangle",
          acceptLabel: "Sí",
          accept: () => {
            eliminarDet(selectedDet);
          },
          rejectLabel: "No",
          reject: () => {},
          style: { backgroundColor: "white" },
        });
      }
    }else{
      const mensaje = selectedEnc.length > 1 
        ? `¿Está seguro de eliminar las cotizaciones?`
        : `¿Está seguro de eliminar la cotización?`;
    
      if (selectedEnc.length <= 0) {
        toastShow(
          toast,
          "warn",
          "Advertencia",
          `Seleccione al menos una cotización.`
        );
      } else {
        confirmDialog({
          message: mensaje,
          header: "Eliminar Cotización",
          icon: "pi pi-exclamation-triangle",
          acceptLabel: "Sí",
          accept: () => {
            eliminarCot(selectedEnc);
          },
          rejectLabel: "No",
          reject: () => {},
          style: { backgroundColor: "white" },
        });
      }
    }
  };

  const eliminarDet = async (Detalles) => {
    Detalles.forEach(async (select) => {
      const respuesta = await EliminarDetalles(select)
    })
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
      toastShow( toast, "success", "Eliminado", Detalles.length > 1 ? "Detalles eliminados correctamente" : 'Detalle eliminado correctamente' );
      getInfo()
    }, 850);
  }

  const eliminarCot = async (Detalles) => {
    Detalles.forEach(async (select) => {
      const respuesta = await EliminarCotizacion(select)
    })
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
      toastShow( toast, "success", "Eliminada", Detalles.length > 1 ? "Cotizaciones eliminadas correctamente" : 'Cotización eliminada correctamente' );
      getInfo()
    }, 850);

  }

  const items = [
    {
      label: "Ingles",
      command: () => {
        const s = activeIndex === 0 ? selectedDet : selectedEnc
        if(s.length > 0){
          if(s.length > 50){
            toastShow( toast, "warn", "Advertencia", "Solo se permite seleccionar 50 cotizaciones");
          }else{
            setSelectedR(s)
            setLenguaje('en')
            setShowReporte(true)
          }
        }else{
          toastShow( toast, "warn", "Advertencia", "Seleccione una cotización.");
        }
      },
    },
    {
   
      label: "Español",
      command: () => {
        const s = activeIndex === 0 ? selectedDet : selectedEnc
        if(s.length > 0){
          if(s.length > 50){
            toastShow( toast, "warn", "Advertencia", "Solo se permite seleccionar 50 cotizaciones");
          }else{
            setSelectedR(s)
            setLenguaje('es')
            setShowReporte(true)
          }
        }else{
          toastShow( toast, "warn", "Advertencia", "Seleccione una cotización.");
        }
      },
    },
  ];


  //----COLUMNAS----
  const columsEnc = [
    {
      header: 'ID',
      headerEn: 'ID',
      field: 'IdQuotation',
      className: 'XXsmall',
      frozen: true,
      hidden: userAuth?.IdRol === 1
    },
    {
      field: "DateStr",
      header: "Fecha",
      headerEn: "Date",
      className: "medium",
      frozen: true,
      Format: "DateTime",
    },
    {
      field: "Quotation",
      headerEn: "No. Quotation",
      header: "No. Cotizacion",
      body: (rowData) => rowData.Quotation,
      Format: "Modal",
      align: "center",
      frozen: true,
      Sumary: "count",
      className: 'small',
      onCellDoubleClicked: ({ data }) => {
        AbrirDialog(data)
      },
    },
    {
      field: "StatusName",
      header: "Estado",
      frozen: true,
      headerEn: "Status",
      className: "Xsmall",
      body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
      Format: "Estado",
    },
    {
      header: 'Cliente',
      headerEn: 'Customer',
      field: 'CustomerName',
      className: 'large',
    },
    {
      header: 'Buyer',
      headerEn: 'Buyer',
      field: 'CompanyName',
      className: 'large',
    },
    {
      header: 'Comentario',
      headerEn: 'Comment',
      field: 'Comment',
      className: 'large',
    },
    {
      header: 'Términos de compra',
      headerEn: 'Payment Term',
      field: 'TermNamePayment',
      className: 'small',
    },
    {
      header: 'Plazo de envío',
      headerEn: 'Shipment Term',
      field: 'TermNameShitment',
      className: 'small',
    },
    {
      header: 'Origen',
      headerEn: 'Origin',
      field: 'Origin',             
      className: 'Xsmall',
    },
    {
      header: 'Agente de Ventas',
      headerEn: 'Sales Agent',
      field: 'UserNameAgent',
      className: 'mesium',
    },
    {
      header: 'Usuario Creación',
      headerEn: 'User Create',
      field: 'UserNameCreate',
      className: 'medium',
    },
    {
      field: "DateCreateStr",
      header: "Fecha Creación",
      headerEn: "Date Create",
      className: "medium",
      Format: "DateTime",
    },
    {
      header: 'Usuario Edición',
      headerEn: 'User Edit',
      field: 'UserNameEdit',
      className: 'medium',
    },
    {
      field: "DateUpdateStr",
      header: "Fecha Edición",
      headerEn: "Edit Date",
      className: "medium",
      Format: "DateTime",
    },
    {
      headerName: 'CIF PRICE $',
      children: [          
        {
          field: 'CifPriceKGTOT',
          header: 'Kilogramo',
          headerEn: 'Kilogram',
          className: 'Xsmall',
          Format: 'Currency',
          frozen: true,
          alignFrozen: 'right',
          Sumary: 'sum',
        },
        {
          field: 'CifPriceLBTOT',
          header: 'Libras',
          headerEn: 'Pound',
          className: 'Xsmall',
          Format: 'Currency',
          frozen: true,
          alignFrozen: 'right',
          Sumary: 'sum',
        },
        {
          field: 'CifPriceYDTOT',
          header: 'Yarda',
          headerEn: 'Yard',
          className: 'Xsmall',
          Format: 'Currency',
          frozen: true,
          alignFrozen: 'right',
          Sumary: 'sum',
        },
      ]
    },
    // {
    //   field: 'TotalCotizacion',
    //   header: 'Total',
    //   headerEn: 'Total',
    //   className: 'Xsmall',
    //   Format: 'Decimal',
    //   frozen: true,
    //   alignFrozen: 'right',
    //   Sumary: 'sum',
    // },
  ]

  const columsDet = [
    {
      header: 'ID',
      headerEn: 'ID',
      field: 'IdQuotationDetail',
      className: 'XXsmall',
      frozen: true,
      hidden: userAuth?.IdRol === 1
    },
    {
      field: "DateStr",
      header: "Fecha",
      headerEn: "Date",
      className: "medium",
      frozen: true,
      Format: "DateTime",
    },
    {
      field: "Quotation",
      headerEn: "No. Quotation",
      header: "No. Cotizacion",
      body: (rowData) => rowData.Quotation,
      Format: "Modal",
      align: "center",
      frozen: true,
      Sumary: "count",
      className: 'small',
      onCellDoubleClicked: ({ data }) => {
        AbrirDialog(data)
      },
    },
    {
      field: "StatusName",
      header: "Estado",
      frozen: true,
      headerEn: "Status",
      className: "Xsmall",
      body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
      Format: "Estado",
    },


    {
      header: 'Fabric Type',
      headerEn: 'Fabric Type',
      field: 'FabricType',
      className: 'large',
    },
    {
      header: 'Fabric Content',
      headerEn: 'Fabric Content',
      field: 'FabricContent',
      className: 'large',
    },
    {
      header: 'Yarn Spec',
      headerEn: 'Yarn Spec',
      field: 'YarnSpec',
      className: 'XXlarge',      
      flex: 1,
      minWidth: 500,
    },
    //
    {
      header: 'Weight GSM',
      headerEn: 'Weight GSM',
      field: 'WeightGSM',
      Format: 'Currency',
      Sumary: 'sum',
      className: 'small',
    },
    {
      header: 'Cuttable GSM',
      headerEn: 'Cuttable GSM',
      field: 'CuttableGSM',
      Format: 'Currency',
      Sumary: 'sum',
      className: 'small',
    },
    {
      header: 'Full Width',
      headerEn: 'Full Width',
      field: 'FullWidth',       
      Format: 'Currency',
      Sumary: 'sum',
      className: 'small',
    },
    {
      header: 'Grade',
      headerEn: 'Grade',
      field: 'Grade',
      className:'Xsmall',
    },
    {
      header: 'Proceso',
      headerEn: 'Process',
      field: 'Process',
      className:'small',
    },

    {
      headerName: 'CIF PRICE $',
      headerNameEn: 'CIF PRICE $',
      children: [
        {
          field: 'CifPriceKG',
          header: 'Kilogramo',
          headerEn: 'Kilogram',      
          frozen: true,
          alignFrozen: 'right',
          className: 'Xsmall',
          Format: 'Currency',
          Sumary: 'sum',
        },
        {
          field: 'CifPriceLB',
          header: 'Libra',
          headerEn: 'Pound',
          className: 'Xsmall',
          frozen: true,
          alignFrozen: 'right',
          Format: 'Currency',
          Sumary: 'sum',
        },
        {
          field: 'CifPriceYD',
          header: 'Yarda',
          headerEn: 'Yard',
          className: 'Xsmall',
          frozen: true,
          alignFrozen: 'right',
          Format: 'Currency',
          Sumary: 'sum',
        },
      ]
    },    
    // {
    //   header: 'Comentario',
    //   headerEn: 'Comment',
    //   field: 'Comment',
    //   className: 'large',
    // },

    // {
    //   header: 'Categoría de Estilo',
    //   headerEn: 'Style Category',
    //   field: 'StyleCategory',
    //   className: 'medium',
    // },
    // {
    //   header: 'Hilo',
    //   headerEn: 'Yarn',
    //   field: 'Title',
    //   className: 'medium',
    // },
    // {
    //   header: 'Estilo de Tejido',
    //   headerEn: 'Fabric Style',
    //   field: 'FabricStyle',
    //   className: 'medium',
    // },
    // {
    //   header: 'Teñido',
    //   headerEn: 'Dye',
    //   field: 'DyeType',
    //   className: 'medium',
    // },
    // {
    //   header: 'Densidad',
    //   headerEn: 'Density',
    //   field: 'Density',
    //   className: 'medium',
    // },
    // {
    //   header: 'Unidad',
    //   headerEn: 'Unit',
    //   field: 'UnitName',
    //   className: 'small',
    // },
    // {
    //   header: 'Usuario Creación',
    //   headerEn: 'User Create',
    //   field: 'UserNameCreate',
    //   className: 'medium',
    // },
    // {
    //   field: "DateCreateStr",
    //   header: "Fecha Creación",
    //   headerEn: "Date Create",
    //   className: "medium",
    //   Format: "DateTime",
    // },
    // {
    //   header: 'Usuario Edición',
    //   headerEn: 'User Edit',
    //   field: 'UserNameEdit',
    //   className: 'medium',
    // },
    // {
    //   field: "DateUpdateStr",
    //   header: "Fecha Edición",
    //   headerEn: "Edit Date",
    //   className: "medium",
    //   Format: "DateTime",
    // },
    // {
    //   headerName: 'Costos',
    //   headerNameEn: 'Cost',
    //   children: [          
    //     {
    //       field: 'KnitCost',
    //       header: 'Tejido',
    //       headerEn: 'Knit Cost',
    //       className: 'Xsmall',
    //       Format: 'Decimal',
    //       Sumary: 'sum',
    //     },
    //     {
    //       field: 'DyeCost',
    //       header: 'Teñido',
    //       headerEn: 'Dye Cost',
    //       className: 'Xsmall',
    //       Format: 'Decimal',
    //       Sumary: 'sum',
    //     },
    //     {
    //       field: 'AdditionalCost',
    //       header: 'Procesos Especiales',
    //       headerEn: 'Special Processes',
    //       className: 'Xsmall',
    //       Format: 'Decimal',
    //       Sumary: 'sum',
    //     },
    //     {
    //       field: 'OtherCost',
    //       header: 'Costos Adicionales',
    //       headerEn: 'Additional Costs',
    //       className: 'Xsmall',
    //       Format: 'Decimal',
    //       Sumary: 'sum',
    //     },
    //   ]
    // },
    // {
    //   field: 'Cantidad',
    //   header: 'Cantidad',
    //   headerEn: 'Quantity',
    //   className: 'Xsmall',
    //   Format: 'Decimal',
    //   frozen: true,
    //   alignFrozen: 'right',
    //   Sumary: 'sum',
    // },
    // {
    //   field: 'UnitCost',
    //   header: 'Precio',
    //   headerEn: 'Price',
    //   className: 'Xsmall',
    //   Format: 'Decimal',
    //   frozen: true,
    //   alignFrozen: 'right',
    //   Sumary: 'sum',
    // },
    // {
    //   field: 'Total',
    //   header: 'Total',
    //   headerEn: 'Total',
    //   className: 'Xsmall',
    //   Format: 'Decimal',
    //   frozen: true,
    //   alignFrozen: 'right',
    //   Sumary: 'sum',
    // },
  ]

  //----TABLAS-----
  const tableEnc = {
    Columns: columsEnc,
    Data: encabezado,
    selected: selectedEnc,
    setSelected: (e) => setSelectedEnc(e),
    showModal: (e) => {},
  }

  const tableDet = {
    Columns: columsDet,
    Data: detalles,
    selected: selectedDet,
    setSelected: (e) => setSelectedDet(e),
    showModal: (e) => {},
  }


  useEffect(() => {
    getInfo();
    setTitlePage(getLabel(baseLang, "cotizaciones", config.language));
  }, [activeIndex]);

  return (
    <div>
      <Toast ref={toast} />
      <ConfirmDialog />
      <Card
        titulo={
          <div className="botones flex-wrap  flex-wrap">
            <h2>{getLabel(baseLang, "cotizaciones", config.language)}</h2>
            <CalendarWeek
              date={dates}
              setDate={setDates}
              buscar={getInfo}
              selectionMode="range"
            />
            <Button
              icon="pi pi-refresh"
              tooltip="Cargar"
              tooltipOptions={{ className: 'purple-tooltip', position: 'top' }}
              onClick={() => getInfo()}
            />
            <Button
              icon="pi pi-plus"
              tooltip="Nueva"
              tooltipOptions={{ className: 'purple-tooltip', position: 'top' }}
              onClick={(e) => setShowDialog(true)}
            />

            <Button
              type="button"
              tooltip="Eliminar"
              icon="pi pi-times"
              className="p-button-danger listado__botones"
              tooltipOptions={{
                className: "purple-tooltip",
                position: "top",
              }}
              onClick={(e) => {
                ejecutarEliminar();
              }}
              tabIndex={7}
            />

          
          </div>
        }
        contenido={
          <div className="pt-4">
            <Loader loading={loading} />

            <TabView
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              <TabPanel header={getLabel(baseLang, "cotizaciones", config.language)}>
                <div style={{ height: '83vh' }}>
                  <AgGrid table={tableEnc} />
                </div>
              </TabPanel>
              <TabPanel header={getLabel(baseLang, "detail", config.language)}>
                <div style={{ height: '83vh' }}>
                  <AgGrid table={tableDet} />
                </div>
              </TabPanel>


            </TabView>
          </div>
        }
      />


      {showDialog && (
        <CotizacionesCRUD1
          showDialog={showDialog}
          setShowDialog={setShowDialog}
          selectedEnc={selectedEnc}
          setSelectedEnc={setSelectedEnc}
          habilitar={habilitar}
          setHabilitar={setHabilitar}
          getInfo={getInfo}
        />
      )}

      {showReporte && (
        <ReporteCotizacion
          showReporte={showReporte}
          setShowReporte={setShowReporte}
          selected={selectedR}
          setSelected={setSelectedR}
          setSelectedEnc={setSelectedEnc}
          setSelectedDet={setSelectedDet}
          lenguaje={lenguaje}
          getInfo={getInfo}
        />
      )}

    </div>
  );
};

export default CotizacionesListScreen;
